import React, { useEffect, useState } from "react";
import "./Favourite_icon.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getAllWishlist, postWishlist } from "../../../features/wishlist/wishlistSlice";
import { useNavigate } from "react-router-dom";

const Favourite_icon = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFavourite, setIsFavourite] = useState(false);

  const is_signin = useSelector((state) => state.auth.is_signin);
  const wishlist = useSelector((state) => state.wishlist.allWishlist);

  
  // useEffect(() => {
  //   dispatch(getAllWishlist());
  // }, [dispatch]);

  // Function to check if product is in wishlist
  const checkIn = (id) => wishlist?.data?.some((item) => item?.product_id === id);

  // Update isFavourite whenever wishlist or props.id changes
  useEffect(() => {
    setIsFavourite(checkIn(props?.id));
  }, [wishlist, props?.id]);

  // Handle wishlist toggle
  const toggleFavourite = async () => {
    if (!is_signin) {
      navigate("/login");
      return;
    }

    const res = await dispatch(postWishlist({ product_id: props?.id }));

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllWishlist());
    }
  };

  return (
    <section className="Favourite_icon_sec">
      <div
        className={`addtofavdiv ${isFavourite ? "active" : ""}`}
        onClick={toggleFavourite}
      >
        <FontAwesomeIcon
          className={`favicon ${isFavourite ? "active" : ""}`}
          icon={faHeart}
        />
      </div>
    </section>
  );
};

export default Favourite_icon;
